import axios from "axios";
import {useState, useContext} from "react";
import { Link } from "react-router-dom"
import { AuthDispatchContext } from "../context/AuthContext";
import { useNavigate } from "react-router";

import Header from "../components/Header";
import Social from "../components/Social";
import { useTranslation } from "react-i18next";
import FormInput from "../components/FormInput";
import ym from "react-yandex-metrika";

const LoginForm: React.FC<{}> = () => {
    const { t } = useTranslation();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useContext(AuthDispatchContext);
    const navigate = useNavigate();

    function Login(){
        setError(null);
        setLoading(true);
        axios.post("/api/auth/login", {
            email, password
        }).then(({data}: any) => {
            dispatch({type: "login", user: data.user});
            navigate("/dashboard")
        }).catch((error: any) => {
            setError(t("form_error_login_invalid"))
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className="auth-form login-form form">
            <div className="form-title">{t("login_form_title")}</div>
            <div className="tip">{t("signin-tip")}</div>
            {error && <div className="auth-error">{error}</div>}
            <FormInput
                label={t("form_label_email")}
                value={email}
                setValue={setEmail}
            />
            <FormInput
                label={t("form_label_password")}
                value={password}
                type="password"
                setValue={setPassword}
            />
            <button disabled={loading} className="auth-submit" onClick={Login}>{t("nav_login")}</button>
            <div className="auth-links">
                <Link className="auth-link" to="/signup"  onClick={() => ym('hit', `user-signup`)}>{t("nav_signup")}</Link>
                <Link className="auth-link" to="/reset-password"  onClick={() => ym('hit', `user-reset-password`)}>{t("nav_reset")}</Link>
            </div>
        </div>
    )
}

const LoginPage: React.FC<{}> = () => {
    return (
        <div className="page-wrapper">
            <Header />
            <div className="light-bg full-page-block">
                <LoginForm />
            </div>
            <Social />
        </div>
    )
}

export default LoginPage;